/** Upper bound on one reconnect wait. */
export const BACKOFF_CAP_MS = 30_000
/** Ceiling of the first wait. */
export const BACKOFF_BASE_MS = 1_000

/**
 * Wait before the next attempt after the n-th consecutive failure (n = 0 first):
 * half the ceiling plus a random half, ceiling `min(30 s, 1 s · 2ⁿ)`. The jitter
 * stops every open tab from hitting the authorizer at once after a network blip.
 */
export function backoffDelayMs(n: number, random: () => number = Math.random): number {
	const ceiling = Math.min(BACKOFF_CAP_MS, BACKOFF_BASE_MS * 2 ** n)
	return Math.round(ceiling / 2 + random() * (ceiling / 2))
}
